const reports = state => state.reports;
const report = state => state.report;

export default {
  reports,
  report
};
